import { useEffect, useState } from "react";

const useStaticResources = (srcArray) => {
  const prefixMap = {
    '/img/logo': 'https://eodhistoricaldata.com',
    // Add more prefix mappings as required
  };

  const [modifiedUrls, setModifiedUrls] = useState([]);

  useEffect(() => {
    if (srcArray && Array.isArray(srcArray)) {
      const urls = srcArray.map((url) => {
        for (const key in prefixMap) {
          if (url.startsWith(key)) {
            return `${prefixMap[key]}${url}`;
          }
        }
        return url;
      });
      setModifiedUrls(urls);
    }
  }, [srcArray, prefixMap]);

  return modifiedUrls;
};

export default useStaticResources;
